export default __webpack_public_path__ + "bf0822722bd4ba6980581add6b4845de.png";